import useProtipManifest, { getNoteKey } from "./useProtipManifest";
import { useGetProtipContentQuery } from "../../api/utility.api.slice";
import { marketName } from "../../utils/helpers";

const useSelfServiceNote = (fieldKey) => {
  const { processDefKey, manifest, isLoading } = useProtipManifest();
  const protipId = manifest?.protips?.[getNoteKey(fieldKey)];
  const { data, isError } = useGetProtipContentQuery(
    { market: marketName, processDefKey, protipId },
    { skip: !protipId }
  );
  return {
    content: data?.content,
    // the content query only reports loading from its next render, so a known
    // id without a body is treated as loading to avoid a flash of static text
    isLoading: isLoading || (!!protipId && !data && !isError),
  };
};

export default useSelfServiceNote;
